import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';

import { LocalStorageService } from '../services/core/local-storage.service';

@Component({
  selector: 'app-sharelocation',
  templateUrl: './sharelocation.page.html',
  styleUrls: ['./sharelocation.page.scss'],
})
export class SharelocationPage implements OnInit {
  isLocation='0';
  isLocationShared='0';
  constructor(private router:Router,private storageService:LocalStorageService
    ,private alertcontroller:AlertController) { }

  ngOnInit() {
  }
  ionViewWillEnter(){
    this.getIsLocationShared();

  }
  getIsLocationShared(){
  console.log('before',this.isLocationShared)
  this.isLocationShared=this.storageService.getShareUserLocation('UserLocationShared')
  console.log('after',this.isLocationShared)
}
  async doNotShare(){
 
    const alert= await this.alertcontroller.create({
      header:"Location",
      message:'Stop Sharing Your Location . are you sure',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: 'Yes',
          handler: () => {
            console.log('Confirm Ok');
            this.isLocation='0'
            this.storageService.setShareUserLocation('UserLocationShared',this.isLocation)
            this.router.navigate(['../tabs/tabs/home'])
          }
        }
      ]

    })
    await alert.present();
  

  }
  async shareMyLocation(){
   
    const alert= await this.alertcontroller.create({
      header:"Thank You",
      message:'Your Location will be used for Delivery purpose.',
      buttons: [
       {
          text: 'Ok',
          handler: () => {
            console.log('Confirm Ok');
            this.isLocation='1';
            this.storageService.setShareUserLocation('UserLocationShared',this.isLocation)
            console.log( this.isLocation);
            this.router.navigate(['../tabs/tabs/home'])
          }
        }
      ]

    });
    await alert.present();
  // this.router.navigate(['../tabs/tabs/home'])


  }
}
